import Radios from 'components/Formik/Radios';
import Link from 'components/Link';
import Parse from 'react-html-parser';

const MarketingRequested = ({ initialValues, data }) => {
    initialValues.marketingRequested = '';
    const {
        would_you_like_to_opt_in,
        this_includes_notification,
        options,
        further_information,
        click_here,
    } = data;
    return (
        <>
            <p className={'small'}>
                {further_information}{' '}
                <Link href="/legal/privacy-policy">{click_here}</Link>.
            </p>
            <p>{Parse(would_you_like_to_opt_in)}</p>
            <p>{Parse(this_includes_notification)}</p>
            <Radios options={options} name="marketingRequested" />
        </>
    );
};

export default MarketingRequested;
